import axios from 'axios';
import Vue from 'vue';
import { Plugins, Capacitor, Device } from '@capacitor/core';
const { Storage } = Plugins;
import { BASE_URL } from '@/constants/constants';

const BASE_SUBSCRIPTION_URL = `${BASE_URL}/account/application/2/subscription`;

export default {
    state: {
        subscriptions: [],
        active_subscription: {},
        building: {}
    },

    actions: {

        clearSubscriptionsData({ commit }) {
            return new Promise((resolve) => {
                commit('setSubscriptions', []);
                commit('setActiveSubscription', {});
                commit('setBuilding', {});
                Storage.clear().then(() => { resolve(); });
            });
        },

        fetchSubscriptions({ commit, dispatch }, headers) {
            return new Promise((resolve, reject) => {
                axios.get(BASE_SUBSCRIPTION_URL, { headers: headers }).then((response) => {
                    commit('setSubscriptions', response.data);
                    commit('setAuthorization', headers.Authorization, { root: true });
                    dispatch('registerPushToken');
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        registerPushToken({ rootState, getters }) {
            const token = getters.getFCMToken;
            const headers = { 'Authorization': rootState.authorization };
            if (token !== false) {
                const data = { 'type': Capacitor.getPlatform(), 'registration_id': token, 'device_id': Device.getUid(), 'active': true };
                axios.post(`${BASE_URL}/account/devices/`, data, { headers: headers }).then((response) => {
                    return response;
                });
            }
        },

        async fetchBuildingProfile({ commit, state, rootState, dispatch }) {
            const headers = { 'Authorization': rootState.authorization };
            const sub = state.active_subscription;
            let response = await axios.get(`${BASE_URL}/api/2.0/subscription/${sub.id}/building_profile`, { headers: headers });
            if (response.status === 200) {
                commit('setBuilding', response.data[0]);
                return Promise.resolve(response.data[0]);
            }
            return Promise.reject();
        },

        getSubscriptionData({ rootState, commit, dispatch }) {
            return new Promise((resolve, reject) => {
                Storage.get({ key: 'subscriptions' }).then((response) => {
                    let subscriptions = JSON.parse(response.value);
                    if (subscriptions && subscriptions.length) {
                        commit('setSubscriptions', subscriptions);
                        dispatch('fetchSubscriptions', { 'Authorization': rootState.authorization });
                        Storage.get({ key: 'active_subscription' }).then((response) => {
                            commit('setActiveSubscription', JSON.parse(response.value));
                            resolve();
                        });
                    } else {
                        reject();
                    }
                });
            });
        },

        async getSubscription({ commit }) {
            const subscription = await Storage.get({ key: 'active_subscription' });
            commit('setActiveSubscription', JSON.parse(subscription.value));
            return subscription;
        }
    },

    mutations: {
        setSubscriptions(state, data) {
            Vue.set(state, 'subscriptions', data);
            Storage.set({
                key: 'subscriptions',
                value: JSON.stringify(data)
            });
        },

        setActiveSubscription(state, data) {
            Vue.set(state, 'active_subscription', data);
            Storage.set({
                key: 'active_subscription',
                value: JSON.stringify(data)
            });
        },

        setBuilding(state, data) {
            Vue.set(state, 'building', data);
            Storage.set({
                key: 'active_building',
                value: JSON.stringify(data)
            });
        },
    },

    getters: {
        getActiveSubscription(state) {
            return state.active_subscription;
        },
        
        getActiveBuilding(state) {
            return state.building;
        }, 

        getUserCan: (state) => (permission) => {
            return state.active_subscription;
        }
    }
};